// removed by extract-text-webpack-plugin
module.exports = {"component":"_1i00DM7zFILWLc1rRPGsGk","textToggle":"_3ewzlQI6XKR_gfvWCaPETn","toggle":"_3gu3c3SEQElfyps3Edf3iw","toggleActive":"_2mtRfSKaVzG2amEX3sNqFk","content":"_3p-RbuxsRkpG9Huk4mCSIf","scrollNotes":"rLqAO3Q7wv83RsXRYa8et"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Health/HealthRecordNotes/HealthRecordNotes.css
// module id = 1265
// module chunks = 0